import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { ClienteAnaliseFinanceiraStatusBadgeModule } from '../status/badge';
import { ClientePipeSharedModule } from '../../pipes';
import { RepresentantePipeSharedModule } from '../../../representante/pipes';

import { ClienteAnaliseFinanceiraFormComponent } from './cliente-analise-financeira-form.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseFinanceiraStatusBadgeModule,
        ClientePipeSharedModule,
        RepresentantePipeSharedModule
    ],
    declarations: [
        ClienteAnaliseFinanceiraFormComponent
    ],
    exports: [
        ClienteAnaliseFinanceiraFormComponent
    ]
})
export class ClienteAnaliseFinanceiraFormModule { }
